import { UserIcon } from '@heroicons/react/24/outline';
import { Popover } from '@base-ui/react/popover';
import { Button } from './Button';
import './UserMenu.css';

interface UserMenuProps {
  /** Signed-in user's email, shown inside the popover. */
  email?: string;
  /** Called when the user activates Logout. */
  onLogout: () => void;
}

/**
 * Account menu for the header: an avatar button (generic person icon) that opens
 * a Base UI Popover containing the signed-in email and a Sign out button. Replaces
 * the inline email span + Sign out button so the header stays uncluttered. The
 * trigger reuses the Interstate Button styling (`ids-btn` secondary / S, icon-only)
 * so it matches the theme toggle; the popover uses the `elevation-overlay` shadow.
 */
export function UserMenu({ email, onLogout }: UserMenuProps) {
  return (
    <Popover.Root>
      <Popover.Trigger
        className="ids-btn ids-btn--secondary ids-btn--s user-menu-trigger"
        aria-label="Account menu"
      >
        <span className="ids-btn__icon" aria-hidden="true">
          <UserIcon />
        </span>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Positioner side="bottom" align="end" sideOffset={8}>
          <Popover.Popup className="user-menu-popup">
            {email && <div className="user-menu-email">{email}</div>}
            <Button variant="secondary" size="S" onClick={onLogout}>
              Sign out
            </Button>
          </Popover.Popup>
        </Popover.Positioner>
      </Popover.Portal>
    </Popover.Root>
  );
}
